import classnames from "classnames";
import isNumber from "lodash/isNumber";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {renderFormattedQuantity} from "@/lib/format.tsx";

import css from "./StepInput.module.css";

export interface StepInputProps {
  step?: number;
  value: number;
  maxValue?: number | null;
  minValue?: number;
  minValueMsg?: string;
  maxValueMsg?: string;
  onChange?: (value: number) => void;
  onOverload?: (overload: boolean) => void;
}

export const StepInput = ({
  step = 1,
  maxValue = null,
  minValue = 0,
  minValueMsg = "Reducing settings below current usage or base subscription levels is not supported.",
  maxValueMsg = "This value can not be increased",
  value,
  onChange,
  onOverload,
}: StepInputProps) => {
  return (
    <div id="step-input">
      <TooltipWrapper toolTip={isNumber(minValue) && value - step < minValue ? minValueMsg : undefined}>
        <button
          className={classnames(
            css.StepInputButton,
            "py-1 px-3 btn btn-outline-gray rounded rounded-3 text-black fw-medium"
          )}
          onClick={() => {
            if (onOverload) {
              onOverload(false);
            }
            const newValue = Math.max(value - step, 0);
            if (newValue !== value && onChange) {
              onChange(newValue);
            }
          }}
        >
          -
        </button>
      </TooltipWrapper>
      <span className={css.StepInputValue}>{renderFormattedQuantity(value, 1)}</span>
      <TooltipWrapper toolTip={isNumber(maxValue) && value + step > maxValue ? maxValueMsg : undefined}>
        <button
          className={classnames(
            css.StepInputButton,
            "py-1 px-3 btn btn-outline-gray rounded rounded-3 text-black fw-medium"
          )}
          onClick={() => {
            const newValue = value + step;
            if (isNumber(maxValue) && newValue > maxValue && onOverload) {
              onOverload(true);
              return;
            }
            if (maxValue === null || newValue <= maxValue) {
              if (newValue !== value && onChange) {
                onChange(newValue);
              }
            }
          }}
        >
          +
        </button>
      </TooltipWrapper>
    </div>
  );
};
